import { render, staticRenderFns } from "./QRCodeComp.vue?vue&type=template&id=36622dca&scoped=true"
import script from "./QRCodeComp.vue?vue&type=script&lang=js"
export * from "./QRCodeComp.vue?vue&type=script&lang=js"
import style0 from "./QRCodeComp.vue?vue&type=style&index=0&id=36622dca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36622dca",
  null
  
)

export default component.exports